import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const getJSON = (path) => axios.get(`${API}${path}`, { withCredentials: true }).then((r) => r.data);
export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (s) => (s ? new Date(s).toLocaleString('en-US', { timeZone: 'America/Chicago', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');
export const houseClass = (n) => (n >= 0 ? 'text-emerald-300' : 'text-red-300');
